import {
  QUOTATION_RELEASE_LIST_GET,
  QUOTATION_RELEASE_DETAIL_GET,
  QUOTATION_RELEASE_HISTORY_APPROVE_GET,
  DOC_RELEASE_LIST_GET,
  FAQ_RELEASE_LIST_GET,
  SOFTWARE_RELEASE_LIST_GET,
  SOFTWARE_MANUAL_FIELD_LIST_GET,
  SOFTWARE_MANUAL_LIST_GET,
  SOFTWARE_PATCH_CONFIG_LIST_GET,
  SOFTWARE_PATCH_LIST_GET,
  SOFTWARE_PATCH_DETAIL_GET,
  SOFTWARE_MANUAL_DETAIL_POST,
  SOFTWARE_MANUAL_CONFIG_LIST_GET,
  SOFTWARE_DETAIL_GET,
  SOFTWARE_STRATEGY_INFO_GET,
  SOFTWARE_HARDWARE_LIST_GET,
  SOFTWARE_STRATEGY_INFO_ALL_GET,
  SOFTWARE_PATCH_BY_MODEL_HARDWARE_INFO_GET,
  SOFTWARE_STRATEGY_INFO_ALL_LIST_GET,
  SOFTWARE_VISIBLE_AREA_CATEGORY_GET,
  SOFTWARE_PUBLISH_LIST_GET,
} from "../../fetch/url";
import { get } from '../../fetch/fetch';
import { actionTypes } from "./constants";
import { curl } from "zh-common-modules";

export const setQuotationRealseList = data => ({
  type: actionTypes.SET_QUOTATION_RELEASE_LIST,
  data
});

export const setQuotationRealseDetail = data => ({
  type: actionTypes.SET_QUOTATION_RELEASE_DETAIL,
  data
});

export const setQuotationRealseHistory = data => ({
  type: actionTypes.SET_QUOTATION_RELEASE_HISTORY_LIST,
  data
});
export const setDocReleaseList = data => ({
  type: actionTypes.SET_DOC_RELEASE_LIST,
  data
});

export const setFaqReleaseList = data => ({
  type: actionTypes.SET_FAQ_RELEASE_LIST,
  data
});

export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});

export const getQuotationReleaseList = (params, cb) => {
  return dispatch => {
    curl
      .get(QUOTATION_RELEASE_LIST_GET, params)
      .then(res => {
        cb && cb(res);
        dispatch(setQuotationRealseList({
          list: res.rows,
          total: res.count,
        }));
      });
  };
};

export const getQuotationDetail = (params, cb) => {
  return dispatch => {
    curl
      .get(QUOTATION_RELEASE_DETAIL_GET, params)
      .then(res => {
        cb && cb(res);
        dispatch(setQuotationRealseDetail(res));
      });
  };
};

export const getQuotationHistory = (params, cb) => {
  return dispatch => {
    get(QUOTATION_RELEASE_HISTORY_APPROVE_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          cb && cb(data);
          dispatch(setQuotationRealseHistory(data));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取报价发布日志异常',
        }));
      });
  };
};

export const getDocReleaseList = (params, cb) => {
  return dispatch => {
    get(DOC_RELEASE_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          cb && cb(data);
          dispatch(setDocReleaseList({
            list: data.rows,
            total: data.count,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取报价发布列表异常',
        }));
      });
  };
};

export const getFaqReleaseList = (params, cb) => {
  return dispatch => {
    get(FAQ_RELEASE_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          cb && cb(data);
          dispatch(setFaqReleaseList({
            list: data.rows,
            total: data.count,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取报价发布列表异常',
        }));
      });
  };
};

export const getSoftwareReleaseList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_RELEASE_LIST_GET, params)
      .then(res => {
        cb && cb(res);
      });
  };
};

export const getSoftWareManualTypeList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_MANUAL_FIELD_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

export const getSoftWareManualList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_MANUAL_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取软件版本，型号，硬件版本对应的补丁集合(版本发布时升级策略选择关卡时使用)
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getPatchConfigList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PATCH_CONFIG_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取补丁发布分页信息
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getPatchList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PATCH_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取补丁发布详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getPatchDetail = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PATCH_DETAIL_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取手册发布详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getManualDetail = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_MANUAL_DETAIL_POST, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 根据产品型号、硬件版本号，获取可配置的手册集合(软件发布时选择手册使用)
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getManualConfigList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_MANUAL_CONFIG_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取软件发布详情根据id
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftDetail = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_DETAIL_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 查询最优升级策略(本系统使用)
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftStrategy = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_STRATEGY_INFO_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 查询所有的升级策略
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftStrategyAll = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_STRATEGY_INFO_ALL_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 根据产品型号获取硬件版本数组
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftwareHardwareList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_HARDWARE_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取软件版本，型号，硬件版本对应的补丁集合
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getPatchByModelHardwareInfo = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PATCH_BY_MODEL_HARDWARE_INFO_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取所有现网版本升级到该版本升级策略
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getAllStrategyList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_STRATEGY_INFO_ALL_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取所有可见产品大类
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getVisibleCategory = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_VISIBLE_AREA_CATEGORY_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取已发布软件版本列表清单
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftwarePublishList = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PUBLISH_LIST_GET, params)
      .then(res => {
        cb && cb(res);
      });
  };
};